import { FontSizes } from '@fluentui/react';
export var getStyles = function (_props) {
    return {
        icon: {
            alignSelf: 'flex-top',
            fontSize: FontSizes.size24,
            margin: '0px 12px 0px 0px',
            paddingTop: '3px'
        },
        senderImage: {
            margin: '4px 12px 0 0',
            maxWidth: '40px',
            selectors: {
                '.ms-Persona-details': {
                    display: 'none'
                }
            }
        }
    };
};
//# sourceMappingURL=NotificationIcon.styles.js.map